<template>
  <div class="form-item">
    <label class="form-label">{{ label }}</label>
    <div class="upload-box">
      <div class="upload-preview">
        <img v-if="value" :src="value" alt="" @error="hideBroken">
        <i v-else class="el-icon-picture-outline"/>
      </div>
      <div class="upload-meta">
        <strong>{{ boxTitle || label }}</strong>
        <small>建議尺寸：{{ detail }}；支援 JPG、PNG、SVG、GIF</small>
      </div>
      <el-button size="mini" @click="$refs.file.click()">選擇圖片</el-button>
      <input ref="file" hidden type="file" accept="image/jpeg,image/png,image/svg+xml,image/gif" @change="pick">
    </div>
  </div>
</template>

<script>
export default {
  props: {label: String, boxTitle: String, detail: String, value: String},
  methods: {
    pick(e) {
      const f = e.target.files && e.target.files[0];
      if (f) this.$emit('upload', f);
      e.target.value = ''
    },
    hideBroken(e) {
      e.target.style.display = 'none'
    }
  }
}
</script>
